import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { MainRoutingModule } from './main-routing.module';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { FuseSidebarModule, FuseThemeOptionsModule, FuseProgressBarModule, FuseWidgetModule } from '@fuse/components';
import { LayoutModule } from 'app/layout/layout.module';
import { ALNIdentityAuthGuard } from './guards/aln-identity-auth.guard';
import { AppGatewayComponent } from '../core/appgateway.component';
import { IdleDialogComponent } from './Idle/idle-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';

@NgModule({
    declarations: [
        MainLayoutComponent,
        AppGatewayComponent,
        IdleDialogComponent,
        LoginComponent
    ],
    imports: [
        MainRoutingModule,
        // Fuse modules
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,
        FuseProgressBarModule,
        FuseWidgetModule,
        LayoutModule,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        ReactiveFormsModule
    ],
    providers: [
        ALNIdentityAuthGuard,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MainModule { }
